import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#F8FAF9] border-t border-gray-200">
      <div className="container py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand Section */}
          <div>
            <div className="mb-4">
              <Logo isDark={false} />
            </div>
            <p className="text-base text-[#2D6A4F] mb-4">
              Transform Through Technology
            </p>
            <p className="text-sm text-[#74827A]">
              Led by Oz Altun, PhD - 20 Years of Innovation in Fitness & Recreation
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#1B4332]">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-base text-[#2D6A4F] hover:text-[#0EA5E9] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/consulting" className="text-base text-[#2D6A4F] hover:text-[#0EA5E9] transition-colors">
                  Consulting Services
                </Link>
              </li>
              <li>
                <Link to="/academy" className="text-base text-[#2D6A4F] hover:text-[#0EA5E9] transition-colors">
                  FITNOVEXA Academy
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-base text-[#2D6A4F] hover:text-[#0EA5E9] transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#1B4332]">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-base text-[#2D6A4F] hover:text-[#0EA5E9] transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-base text-[#2D6A4F] hover:text-[#0EA5E9] transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="text-base text-[#2D6A4F] hover:text-[#0EA5E9] transition-colors">
                  Health Disclaimer
                </Link>
              </li>
              <li>
                <Link to="/cookie" className="text-base text-[#2D6A4F] hover:text-[#0EA5E9] transition-colors">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#1B4332]">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Mail size={18} className="mt-1 flex-shrink-0 text-[#0EA5E9]" />
                <a href="mailto:info@fitnovexa.com" className="text-base text-[#2D6A4F] hover:text-[#0EA5E9] transition-colors">
                  info@fitnovexa.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Phone size={18} className="mt-1 flex-shrink-0 text-[#0EA5E9]" />
                <a href="tel:+12025054544" className="text-base text-[#2D6A4F] hover:text-[#0EA5E9] transition-colors">
                  (202) 505-4544
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={18} className="mt-1 flex-shrink-0 text-[#0EA5E9]" />
                <span className="!text-base text-[#2D6A4F]">Virginia</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-[#74827A] text-center md:text-left">
              FITNOVEXA LLC | Founded by Oz Altun, PhD| Transform Through Technology
            </p>
            <p className="text-sm text-[#74827A]">
              © {currentYear} FITNOVEXA LLC. All Rights Reserved.
            </p>
          </div>
          <div className="mt-4 text-center">
            <p className="text-xs text-[#74827A]">
              20 Years Experience | Doctoral Expertise | Proven Results | Technology Pioneer
            </p>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;